import React, { FC, useCallback, useContext } from 'react';

import { Grid } from '@material-ui/core';

import { GlobalContext } from '../../../../../../store';

import Button from '../../../../../../components/Button';
import {
  useAssignResultsDispatch,
  useAssignResultsState
} from '../../AssignResults/Context/AssignResults.context';
import { useRouteInfoState } from '../../../../../../components/RouteInfo/Context/RouteInfo.context';

const AwardsActionsButtons: FC = () => {
  const { clubId, eventId, roundId } = useRouteInfoState();

  const {
    results,
    selectedCombination,
    awardsToUpdate,
    editMode,
    teamResults
  } = useAssignResultsState();

  const {
    dispatch,
    actions: { setCombinations }
  } = useAssignResultsDispatch();

  const {
    actions: {
      adminRoundFormatAwards: { create: createRoundFormatAwards },
      adminEventFormatAwards: { create: createEventFormatAwards }
    }
  } = useContext(GlobalContext);

  const toggleEditmode: () => void = () => dispatch({ type: 'toggleEditMode' });

  const onSaveUpdates = useCallback(async () => {
    if (selectedCombination) {
      if (roundId) {
        await createRoundFormatAwards(
          roundId,
          selectedCombination.id,
          Object.values(awardsToUpdate).flat()
        );

        dispatch({ type: 'resetAwardToUpdate' });
      } else {
        await createEventFormatAwards(
          clubId,
          eventId,
          selectedCombination.id,
          Object.values(awardsToUpdate)
        );
      }
      dispatch({ type: 'toggleEditMode' });
      setCombinations(Number(clubId), Number(eventId), Number(roundId));
    }
  }, [clubId, eventId, roundId, selectedCombination, awardsToUpdate]);

  return (
    <>
      {(results.length > 0 || teamResults.length > 0) && (
        <>
          {editMode || <Grid className="grid-item" item={true} xs={6} />}
          <Grid className="grid-item" item={true} xs={6}>
            <Button
              variant="outlined"
              color="primary"
              fullWidth={false}
              className="button"
              onClick={() => toggleEditmode()}
            >
              {editMode ? 'Cancel' : 'Edit Awards'}
            </Button>
          </Grid>
        </>
      )}
      {editMode && (
        <>
          <Grid className="grid-item" item={true} xs={6}>
            <Button
              variant="contained"
              color="primary"
              fullWidth={false}
              className="button"
              onClick={onSaveUpdates}
            >
              Save Updates
            </Button>
          </Grid>
        </>
      )}
    </>
  );
};

export default AwardsActionsButtons;
